
import Vue, { PropType } from 'vue';
import { minLength, required } from 'vuelidate/lib/validators';
import { Floor, FloorEdit } from '@/interfaces/locations';
import Modal from '@/components/modal/Modal.vue';
import { Validation } from 'vuelidate/vuelidate';

interface AreaForm {
	name: string;
	description: string;
	editMode: boolean;
}

export default Vue.extend({
	components: {
		Modal,
	},
	data() {
		return {
			area: undefined,
			areaForm: {
				name: '',
				description: '',
				editMode: false,
			},
		} as {
			area: Floor | undefined;
			areaForm: AreaForm;
		};
	},

	validations: {
		areaForm: {
			name: {
				required,
				minLength: minLength(3),
			},
			description: {},
		},
	},

	props: {
		floors: { type: Array as PropType<Floor[]>, default: (): Floor[] => [] },
	},

	methods: {
		showModal(id?: number) {
			if (id) {
				this.area = this.floors.find((floor: Floor) => floor.id === id);
				this.areaForm.editMode = true;
			}

			if (this.area) {
				this.areaForm.name = this.area.name;
				this.areaForm.description = this.area.description;
			}

			this.$bvModal.show('modal-area');
		},

		hide() {
			this.$bvModal.hide('modal-area');
		},

		resetAreaModal() {
			this.area = undefined;
			this.areaForm = {
				name: '',
				description: '',
				editMode: false,
			};
			this.$v.areaForm.$reset();
		},

		async confirmAreaModal() {
			this.$v.areaForm.$touch();

			if (this.$v.areaForm.$anyError) {
				return;
			}

			let newArea: FloorEdit = {
				name: this.areaForm.name,
				description: this.areaForm.description,
			};

			if (this.area && this.areaForm.editMode) {
				this.$emit('changeArea', 'locations/floors/modifyFloor', newArea, this.area.id);
			} else {
				this.$emit('newArea', 'locations/floors/addFloor', newArea);
			}
		},

		validateState(validation: Validation): boolean | null {
			const { $dirty, $error }: { $dirty: boolean; $error: boolean } = validation;
			return $dirty ? !$error : null;
		},

		closeAreaModal(): void {
			this.$bvModal.hide('modal-area');
		},
	},
});
